<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2>Revenue Detail Scan  </h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-5">
                    <div class="card p-3">
                        <div class="card-header bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">Profit and Loss Revenue Details with MSRB</h5>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div class="ml-2 mb-2 mt-3 float-right">
                            <p v-if="lastUploadedDateMSRB" style="color: #086f08;font-weight: 500;" class="modalp text-left">MSRB : {{moment(lastUploadedDateMSRB).format("MMMM DD YYYY, h:mm:ss a")}}</p>
                            <p v-if="lastUploadedDatePL" style="color: #086f08;font-weight: 500;" class="modalp  text-left">P&L : {{moment(lastUploadedDatePL).format("MMMM DD YYYY, h:mm:ss a")}}</p>
                        </div>
                        </div>
                        <span class="round"><img src="@/assets/img/vector/download.png" alt /></span>

                        
                        <form class="">
                            
                            <div class="form-row settings">
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Trade Date From</label>
                                    <datepicker 
                                        v-model="settilementDateFrom" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Trade Date To </label>
                                    <datepicker 
                                        v-model="settilementDateTo" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div>
                                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                <div class="form-group col-md-12 text-center">
                                    <!-- <button type="button" class="btn btn-light">RESET</button> -->
                                    <button @click="exportData()" type="button" class="btn btn-success">EXPORT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsComponent",
  components : {
      Datepicker
  },
  data() {
    return {
        settilementDateFrom :null,
        settilementDateTo :null,
        loading : false,
        disabledDates: {
          to: this.getYestedayDate()
        },
        lastUploadedDateMSRB : "",
        lastUploadedDatePL : "",

    };
  },
  methods: { 
    filelogs(){
            this.loading = true;
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlAutoBidder + "/logs/file-upload"+
                "?offset=0&limit=1&fetchLatestCreatedDates=true&fileType=MSRB,PROFITANDLOSS_UPLOAD",
                auth
              )
              .then((result) => {
                  this.lastUploadedDateMSRB = result.data.MSRB;
                  this.lastUploadedDatePL = result.data.PROFITANDLOSS_UPLOAD;
                  this.loading = false;

              })
              .catch(e => {
                console.log(e);
                this.loading = false;
              });
    },
    exportData(){
        this.loading = true;
        //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
        let fromDate = this.settilementDateFrom ? this.moment(this.settilementDateFrom).format("MM/DD/YYYY")  : "" ;
        let toDate = this.settilementDateTo ? this.moment(this.settilementDateTo).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/pnl/msrb-report?fromDate="+fromDate+"&toDate="+toDate+"&cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then((response) => {
            this.loading = false;
            if(response.data){
                window.open(response.data, "_blank");
            }
        }).catch(() => this.loading = false)     

    }
  },
  mounted() {

    this.settilementDateFrom = this.moment().subtract(1,'days').format("MM-DD-YYYY");
    this.settilementDateTo = this.moment().subtract(1,'days').format("MM-DD-YYYY");
    this.filelogs()
    
  }
};
</script>